// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"FormSubmitButton_submitButton__ZEsJa","submitButtonWithoutMargin":"FormSubmitButton_submitButtonWithoutMargin__yPEg0"};